<!-- カメラ全調整モード（交換/脱着） -->
<b-modal v-model="modal_requirement_167" size="md" :header-bg-variant="headerColor" header-text-variant="light"
  no-close-on-backdrop no-close-on-esc centered no-stacking>
  <template v-slot:header>
    <div class="text-center w-100">
      <!-- 確認 -->
      <template v-if="['standby', 'correct_standby', 'rate_standby', 'cancel'].includes(phase)">
        {{ $t('message.common_title_confirmation') }}
      </template>
      <!-- 実行中 -->
      <template
        v-if="['aiming_monitoring', 'correct_monitoring', 'rate_monitoring', 'init_monitoring', 'clear_monitoring'].includes(phase)">
        {{ $t('individual.common_title_execution') }}
      </template>
      <!-- 成功 -->
      <template v-if="['display_status_success', 'correct_stop'].includes(phase)">
        {{ $t('message.common_title_success') }}
      </template>
      <!-- エラー -->
      <template v-if="['aiming_stop_error', 'timeout_error', 'failed', 'display_status_error'].includes(phase)">
        {{ $t('message.common_title_error') }}
      </template>
    </div>
  </template>

  <template v-slot:default>
    <b-overlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <div class="container-fluid" style="min-height: 140px;">
        <div class="row no-gutters">
          <div class="col-12">
            <div class="text-left align-middle">
              <div class="box-margin-right work-support-message" style="white-space: break-spaces;">{{ displayInfo }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
  </template>

  <template v-slot:footer>
    <div class="w-100 text-center ">
      <!-- キャンセル表示 -->
      <template v-if="phase === 'cancel'">
        <b-button size="sm" :disabled="isLoading" variant="primary" @click="exeTerminate()" class="mx-2">
          {{ $t('individual.common_button_yes') }}
        </b-button>
        <b-button size="sm" :disabled="isLoading" variant="outline-primary" @click="abortCancel()" class="mx-2">
          {{ $t('individual.common_button_no') }}
        </b-button>
      </template>
      <!-- 待機 -->
      <template v-if="phase === 'standby'">
        <b-button size="sm" :disabled="isLoading" variant="primary" @click="onClickStandbyOK()" class="mx-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </template>
      <!-- カメラ全調整モード 異常終了表示 -->
      <template v-if="phase === 'aiming_stop_error'">
        <b-button size="sm" :disabled="isLoading" variant="primary" @click="updatePhase('correct_standby')"
          class="mx-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </template>
      <!-- 距離補正 待機 -->
      <template v-if="phase === 'correct_standby'">
        <b-button size="sm" :disabled="isLoading" variant="primary" @click="onClickCorrectOK()" class="mx-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </template>
      <!-- 距離補正 停止 -->
      <template v-if="phase === 'correct_stop'">
        <b-button size="sm" :disabled="isLoading" variant="primary" @click="updatePhase('rate_standby')" class="mx-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </template>
      <!-- 正解率検査 待機 -->
      <template v-if="phase === 'rate_standby'">
        <b-button size="sm" :disabled="isLoading" variant="primary" @click="onClickRateOK()" class="mx-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </template>
      <!-- Status表示・エラー表示 -->
      <template v-if="['display_status_success', 'display_status_error', 'timeout_error', 'failed'].includes(phase)">
        <b-button size="sm" :disabled="isLoading" variant="primary" @click="exeTerminate()" class="mx-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </template>
      <!-- 各待機画面のキャンセルボタン -->
      <template v-if="['standby', 'correct_standby', 'rate_standby', 'aiming_stop_error'].includes(phase)">
        <b-button size="sm" :disabled="isLoading" variant="outline-primary" @click="displayCancel()" class="mx-2">
          {{ $t('message.common_button_cancel') }}
        </b-button>
      </template>
    </div>
  </template>
</b-modal>